export default __webpack_public_path__ + "static/media/Banner1.b35cf70d.jpg";